import React from 'react';
import type { RichTextReadRenderer } from '../rich-text/rich-text-field-read-module.ts';
import { RichTextValueView } from '../rich-text/rich-text-value-view.tsx';
import type { AiSummaryReadContent } from './ai-summary-field-read-module.ts';
import styles from './ai-summary-value-view.module.css';

const renderValue: RichTextReadRenderer = (content) => (
  <RichTextValueView content={content} />
);

/**
 * The application owns rich providers; terminal empty outcomes need no renderer load.
 */
export function AiSummaryValueView({
  content,
  renderRichText = renderValue
}: {
  readonly content: AiSummaryReadContent;
  readonly renderRichText?: RichTextReadRenderer;
}) {
  return content.kind === 'ai-summary-empty' ? (
    <div className={styles.emptyOutcome}>{content.text}</div>
  ) : (
    renderRichText(content)
  );
}
